import Date from "@components/Atoms/Date";
import t from "@ext/localization/locale/translate";
import { SearchMarkedText } from "@ext/serach/components/results/SearchMarkedText";
import type { SearchResultMarkItem } from "@ext/serach/Searcher";
import { TextOverflowTooltip } from "@ui-kit/Tooltip";

export type ChatSessionLabelProps = {
	title: string;
	titleMarks?: SearchResultMarkItem[] | null;
	createdAt?: number;
};

export const ChatSessionLabel = ({ title, titleMarks, createdAt }: ChatSessionLabelProps) => (
	<>
		<TextOverflowTooltip className="min-w-0 flex-1">
			{titleMarks ? <SearchMarkedText marks={titleMarks} /> : title || t("agent.history.new-chat")}
		</TextOverflowTooltip>
		{createdAt && <Date className="shrink-0 text-muted" date={createdAt} />}
	</>
);
